import BaseRepository from './base.repository';

/**
 * Payment Repository
 * Xử lý các API calls liên quan đến payment
 */
class PaymentRepository extends BaseRepository {
  constructor() {
    super('payment');
  }

  /**
   * Kiểm tra trial eligibility (DEPRECATED - use checkTrialEligibilityGlobal instead)
   * @param {number} packageId - Package ID
   * @returns {Promise<Object>} Response với eligibility info
   */
  checkTrialEligibility(packageId) {
    return this.client.get('/trial/check', { package_id: packageId });
  }

  /**
   * Kiểm tra trial eligibility globally (1 user chỉ được trial 1 lần)
   * @returns {Promise<Object>} Response với eligibility info
   */
  checkTrialEligibilityGlobal() {
    return this.client.get('/trial/check-global');
  }

  /**
   * Tạo trial payment (7 ngày miễn phí)
   * @param {Object} data - { package_id, duration }
   * @returns {Promise<Object>} Response với QR code URL
   */
  createTrialPayment(data) {
    return this.client.post('/trial', data);
  }

  /**
   * Tạo paid payment với QR code
   * @param {Object} data - { package_id, duration }
   * @returns {Promise<Object>} Response với QR code URL
   */
  createPaidPayment(data) {
    return this.client.post('/paid', data);
  }

  /**
   * Tạo payment thông thường (VNPay)
   * @param {Object} data - { package_id, duration, payment_method }
   * @returns {Promise<Object>} Response với payment URL
   */
  createPayment(data) {
    return this.client.post('/create', data);
  }

  /**
   * Lấy lịch sử giao dịch
   * @param {Object} params - { page, limit, status, payment_method, date_from, date_to }
   * @returns {Promise<Object>} Response với danh sách giao dịch
   */
  getPaymentHistory(params = {}) {
    return this.client.get('/history', params);
  }

  /**
   * Lấy chi tiết giao dịch
   * @param {string} transactionId - Transaction ID
   * @returns {Promise<Object>} Response với chi tiết giao dịch
   */
  getPaymentDetail(transactionId) {
    return this.client.get(`/${transactionId}`);
  }

  /**
   * Kiểm tra trạng thái giao dịch
   * @param {string} transactionId - Transaction ID
   * @returns {Promise<Object>} Response với trạng thái giao dịch
   */
  checkPaymentStatus(transactionId) {
    return this.client.get(`/status/${transactionId}`);
  }

  /**
   * Validate mã giảm giá
   * @param {Object} data - { promotion_code, package_id }
   * @returns {Promise<Object>} Response với thông tin promotion
   */
  validatePromotion(data) {
    return this.client.post('/validate-promotion', data);
  }
}

export default new PaymentRepository();

